let baseURL = 'https://api.paddycover.com/v1'

export default baseURL
